import React, { useMemo } from 'react';
import { View } from 'react-native';
import NotesEditor from '../../../shared/Notes/NotesEditor';
import { useEditNote } from '../../../../hooks/api/useNotes';
import { ProfileNoteDestination } from '../../../shared/Notes/utils/types';

export type AddNoteContentOwnProps = {
    onClose: (force: boolean) => void;
    profileId: string;
};

export type AddNoteContentProps = AddNoteContentOwnProps;

const AddNoteContent: React.FC<AddNoteContentProps> = (props) => {
    const noteDestination = useMemo<ProfileNoteDestination>(
        () => ({
            medicalProfileId: props.profileId,
            entityType: 'medical-profile',
        }),
        [props.profileId],
    );
    const { noteEditorProps, key } = useEditNote({
        noteDestination,
        onCreationSuccess: () => {
            props.onClose(true);
        },
    });
    return (
        <View style={{ width: '100%', height: '100%' }}>
            <NotesEditor
                key={key}
                source="profile-activity.recent-notes-drawer"
                onCancel={() => props.onClose(true)}
                noteDestination={noteDestination}
                disableRecording
                {...noteEditorProps}
            />
        </View>
    );
};

export default React.memo(AddNoteContent);
